import { makeStyles, Text } from "@fluentui/react-components";
import { IRunwayInfo } from "../../../../utils/maps/MapConstants";
import RunwayConditions from "./RunwayConditions";

export interface IRSCMarkerTooltipProps {
  airportCode: string;
  runwayName: string;
  current: IRunwayInfo;
  prior: IRunwayInfo;
}

const RSCMarkerTooltip: React.FC<IRSCMarkerTooltipProps> = ({
  airportCode,
  runwayName,
  current,
  prior,
}) => {
  const styles = useStyles();

  return (
    <article className={styles.card} data-testid="rsc-marker-tooltip">
      <header className="pb-sm-1">
        <Text weight="bold" size={400}>
          Runway Conditions
        </Text>
      </header>
      <div style={{ display: "flex", gap: "16px" }}>
        <RunwayConditions
          airportCode={airportCode}
          runwayName={runwayName}
          {...current}
          isCurrent={true}
        />
        <RunwayConditions
          airportCode={airportCode}
          runwayName={runwayName}
          {...prior}
          isCurrent={false}
        />
      </div>
    </article>
  );
};

export default RSCMarkerTooltip;

const useStyles = makeStyles({
  card: {
    padding: "2px",
  },
});
